'use strict';

/* Controllers */
(function () {
    angular.module('pt.controllers')
      .controller('scheduledMaintenanceCtrl',
      ["$scope", function($scope){

      }]);
})();